/**
 * CMS Client for Ibjerget
 * Uses Auxo Public API endpoints
 */

const API_BASE = 'https://api.dev.auxo.dk/public';

// Sizable Cloudflare image helper
export function getOptimizedImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string') return '';
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }
  const opts = [];
  if (options.width) opts.push(`width=${options.width}`);
  if (options.height) opts.push(`height=${options.height}`);
  if (options.quality) opts.push(`quality=${options.quality || 80}`);
  opts.push('format=auto');
  if (options.fit) opts.push(`fit=${options.fit}`);

  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${opts.join(',')}/`);
}

export async function fetchCollection(collectionName, params = {}) {
  try {
    const url = new URL(`${API_BASE}/v2/content/${collectionName}`);
    Object.entries(params).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== '') {
        url.searchParams.append(key, String(val));
      }
    });

    const res = await fetch(url.toString());
    if (!res.ok) {
      // Fallback to legacy endpoint if v2 returns error
      const legacyRes = await fetch(`${API_BASE}/content/${collectionName}`);
      if (legacyRes.ok) {
        const data = await legacyRes.json();
        return { items: Array.isArray(data) ? data : [], total: Array.isArray(data) ? data.length : 0 };
      }
      return { items: [], total: 0 };
    }
    const data = await res.json();
    return {
      items: Array.isArray(data.items) ? data.items : [],
      total: data.total || (Array.isArray(data.items) ? data.items.length : 0)
    };
  } catch (err) {
    console.error(`Error fetching collection ${collectionName}:`, err);
    return { items: [], total: 0 };
  }
}

export async function fetchEntryBySlug(slug, lang = null) {
  try {
    const path = lang ? `/by-slug/${lang}/${slug}` : `/by-slug/${slug}`;
    const res = await fetch(`${API_BASE}${path}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error(`Error fetching entry by slug ${slug}:`, err);
    return null;
  }
}
